/**
 *
 * @param {*} file
 * @param {*} header
 * @returns {Promise<Array<Array<string|number|Date>> | Promise<Array<object>>}
 */
export async function getData(file, header) {
    const dynamicGetImportFromWorkbook = await import(
        // avoid warning for dynamic import (which seems to need the extension)
        // eslint-disable-next-line import/extensions
        /*webpackChunkName WorkbookForImport*/ './dynamicGetImportFromWorkbook.js'
    );
    return await dynamicGetImportFromWorkbook.default(file, header);
}

export default {
    getData
};
